<template>
  <div class="allTotal">
    <div
      class="middle-mark"
      :style="{ backgroundImage: 'url(' + ossUrl + '/grade_bg.png)' }"
      @click="showHealthSign"
    >
      <div class="marksTxt">{{ marks }}</div>
      <div class="circletxt">健康度</div>
    </div>
    <div class="total-list">
      <div v-for="(item, index) in totalList" :key="index" class="special">
        <div class="risk_top">
          <div>
            <img :src="ossUrl + '/special' + (index + 1) + '.png'" />{{
              item.title
            }}
          </div>
          <div class="status-list">
            <div
              v-if="item.title === '机能水平'"
              v-for="child in ristStatusTwo"
              :key="child.id"
              :class="
                child.id == item.status ? 'active ristStatus' : 'ristStatus'
              "
            >
              {{ child.name }}
            </div>
            <div
              v-if="item.title !== '机能水平'"
              v-for="child in ristStatus"
              :key="child.id"
              :class="
                child.id == item.status ? 'active ristStatus' : 'ristStatus'
              "
            >
              {{ child.name }}
            </div>
          </div>
        </div>
        <div v-if="item.showCon" class="risk_cont">
          <!-- <div class="red_title">常见免疫风险</div> -->
          <span v-html="item.desc"></span>
          <div v-if="item.result" class="red_title">本次结果 【{{item.functional_status}}】</div>
          <div>{{ item.result }}</div>
        </div>
        <div
          v-if="item.desc || item.result"
          class="risk_btn"
          @click="handleContent(item)"
        >
          {{ item.btntxt }}
          <img
            :class="item.showCon ? 'rotates' : ''"
            :src="ossUrl + '/down.png'"
          />
        </div>
      </div>
    </div>
    <model-div title="名词解释及数值划分" :show-sign="showSign" @hide-signs="hideSigns">
       <span v-html="signText"></span>
    </model-div>
  </div>
</template>
<script>
import { ossUrl } from "@/config";
import ModelDiv from "@/components/ModelDiv"

export default {
  name: "TotalList",
  components: {
      ModelDiv
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    marks: {
        type: Number,
        default: ''
    }
  },
  data() {
    return {
      showSign: false,
      signTitle: '',
      signText: '',
      ossUrl,
      ristStatus: [
        { name: "低", id: 1 },
        { name: "偏低", id: 2 },
        { name: "中", id: 3 },
        { name: "偏高", id: 4 },
        { name: "高", id: 5 },
      ], // 风险等级
      ristStatusTwo: [
        { name: "高", id: 5 },
        { name: "偏高", id: 4 },
        { name: "中", id: 3 },
        { name: "偏低", id: 2 },
        { name: "低", id: 1 },
      ], // 风险等级2
      totalList: [],
    };
  },
  created() {
    this.totalList = this.list
  },
  methods: {
    handleContent(item) {
      if (item.showCon) {
        item.btntxt = "查看建议";
      } else {
        item.btntxt = "收起";
      }
      item.showCon = !item.showCon;
    },
    showHealthSign() {
      const signText= `健康度是一项全身综合健康指标,60分及格，满分100，分值越高越好。<br>
        0-59，差；<br>
        60-74，中；<br>
        75-84，良；<br>
        85-100，优。`
        this.showSign = true,
        this.signText = signText,
        this.signTitle = '健康度'       
    },
    hideSigns() {
      this.showSign = false
      this.signText = ''                                                
    },
  },
};
</script>
<style lang="scss" scoped>
.allTotal {
  margin-top: 30px;
}
.organ_list {
  position: relative;
  z-index: 5;
  margin: 10px auto;
  padding-bottom: 0;
  background-color: #fff;
}

.list_top {
  background-color: transparent;
  padding: 5px;
  box-shadow: none;
}
.list_bottom {
  background-color: transparent;
  padding: 10px 0 20px;
}
.list_bottom .risks {
  height: 150px;
}
.list_bottom .diseasa-risks div {
  width: 209px;
  margin-left: 10px;
}
/* .list_bottom .diseasa-risks div:nth-child(3n+1) {
  margin-left: 0;
} */
.list_bottom .diseasa-risks div:nth-child(4n + 1) {
  margin-left: 10px;
}
.person {
  top: 0;
}
.middle-mark {
  position: relative;
  width: 340px;
  height: 340px;
  margin: 40px auto;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  font-size: 50px;
  color: #929292;
  border-radius: 50%;
}
.middle-mark > div {
  margin-top: 30px;
}
.middle-mark > .marksTxt {
  position: absolute;
  top: 30px;
  left: 0;
  text-align: center;
  font-weight: 600;
  width: 100%;
  font-size: 120px;
  height: 140px;
  color: #1681e1;
}
.circletxt {
  position: absolute;
  top: 190px;
  left: 0;
  text-align: center;
  width: 100%;
  height: 40px;
}
.cicle .bar {
  position: absolute;
  width: 325px;
  height: 325px;
  left: 0;
  right: 0;
  /* overflow: hidden; */
  z-index: 5;
}
.cicle .bar-left {
  top: 15px;
  left: 15px;
}
.cicle .bar-left .bar-left-an {
  position: absolute;
  z-index: 10;
  width: 292px;
  height: 292px;
  border-width: 10px;
  border-color: transparent transparent #5fc5e0 #5fc5e0;
  border-style: solid;
  border-radius: 50%;
  transform: rotate(-135deg);
}
.cicle .bar-right {
  top: -1px;
  left: -101px;
}
.cicle .bar-right .bar-right-an {
  position: absolute;
  top: 17px;
  left: 116px;
  z-index: 20;
  width: 292px;
  height: 292px;
  border-width: 10px;
  border-color: #5fc5e0 #5fc5e0 transparent transparent;
  border-style: solid;
  border-radius: 50%;
  transform: rotate(-135deg);
}
.dialog .box .status {
  display: flex;
  align-items: center;
  height: 102px;
  flex-wrap: wrap;
}
.dialog .box .status > div {
  width: 100%;
}
.dialog .box .status > div:first-child {
  margin-top: 0;
}
/* news */
/* 背景白点 */
.man-middle-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
}
.man-bottom-bg {
  position: absolute;
  width: 750px;
  top: 1150px;
  width: 100%;
  margin-bottom: -60px;
}
.total-list {
  width: 700px;
  margin: auto;
}
.special {
  background-color: #fff;
  padding: 0 25px;
  margin: 0 auto 20px;
}
.risk_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding: 30px 0;
  font-size: 34px;
}
.risk_top > div:first-child {
  display: flex;
  align-items: center;
}
.risk_top img {
  width: 42px;
  height: 42px;
  vertical-align: middle;
  margin-right: 16px;
}
.status-list {
  display: flex;
}
.status-list .ristStatus {
  width: 68px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  background-color: #b5b5b5;
  border-left: 1px solid #fff;
  font-size: 24px;
  text-align: center;
}
.statuslist .active {
  position: relative;
}
.statuslist .active::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: -20px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom-width: 20px;
  border-bottom-style: solid;
}
.ristStatus:nth-child(1) {
  background-color: #009944;
}
.ristStatus:nth-child(1).active::before {
  border-bottom-color: #009944;
}
.ristStatus:nth-child(2) {
  background-color: #a2e317;
}
.ristStatus:nth-child(2).active::before {
  border-bottom-color: #a2e317;
}
.ristStatus:nth-child(3) {
  background-color: #f29238;
}
.ristStatus:nth-child(3).active::before {
  border-bottom-color: #f29238;
}
.ristStatus:nth-child(4) {
  background-color: #dd352a;
}
.ristStatus:nth-child(4).active::before {
  border-bottom-color: #dd352a;
}
.ristStatus:nth-child(5) {
  background-color: #a01d18;
}
.ristStatus:nth-child(5).active::before {
  border-bottom-color: #a01d18;
}
.risk_cont {
  font-size: 28px;
  color: #616161;
  padding: 25px 0;
  border-bottom: 1px solid #ddd;
  text-align: left;
}
.red_title {
  font-size: 28px;
  color: #d30909;
  margin: 25px 0 5px;
  font-weight: bold;
}
.risk_btn {
  font-size: 24px;
  color: #949494;
  padding: 25px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.risk_btn img {
  width: 21px;
  height: 11px;
  margin-left: 5px;
}
.risk_btn img.rotates {
  transform: rotate(180deg);
}
</style>